import './MessageGrid.scss'
import { Column, Item, Toolbar } from "devextreme-react/data-grid";
import { Button } from "devextreme-react/button";
import { useCallback, useState } from "react";
import ViewMessagePopup from "./ViewMessagePopup";
import CreateMessagePopup from "./CreateMessagePopup";
import { MessageGridProps } from "../types/MessageGridProps";
import { InvalidateOptions, useQueryClient } from "@tanstack/react-query";
import { useAuth } from '../../../../contexts/auth';
import { SyncDataGrid } from '../../../../components';

export default function MessageGrid(props: MessageGridProps) {

	const { user } = useAuth();
	const [viewMessageID, setViewMessageID] = useState(props.messageID);
	const [createMessagePopupVisible, setCreateMessagePopupVisible] = useState(props.messageText !== undefined);
	const queryClient = useQueryClient();

	const rowPrepared = useCallback((e: any) => {
		if (e.rowType === "data") {
			if (!e.data.isRead) {
				e.rowElement.classList.add("unread");
			}
		}
	}, []);

	return (
		<>
			<SyncDataGrid
				className={'dx-card wide-card message-grid'}
				dataSource={props.messages}
				allowColumnReordering={true}
				allowColumnResizing={true}
				showBorders={true}
				showColumnLines={true}
				columnAutoWidth={false}
				keyExpr={'notificationQueueID'}
				height='62vh'			
				onRowPrepared={rowPrepared}
			>
				<Toolbar>
					<Item location="after">
						<Button
							type="default"
							text="New Message"
							icon="Inscyth-New-Message"
							onClick={() => setCreateMessagePopupVisible(true)}
						/>
					</Item>
				</Toolbar>

				<Column
					dataField={'messageType'}
					caption={'Message Type'}
					dataType="string"
					width={100}
				>
				</Column>
				<Column
					dataField={'createdOn'}
					caption={'Created On'}
					dataType="datetime"
					width={140}
				/>
				<Column
					dataField={'from'}
					caption={'From'}
					dataType="string"
				/>
				<Column
					dataField={'to'}
					caption={'To'}
					dataType="string"
				/>
				<Column
					dataField={'messageText'}
					caption={'Message'}
					dataType="string"
					width={'25%'}
				/>
				<Column
					dataField={'status'}
					caption={'Status'}
					dataType="string"
					width={100}
				/>
				<Column
					width={70}
					cellRender={(row: any) => {
						return <a onClick={() => {
							setViewMessageID(row.data.notificationQueueID);
						}}>View</a>
					}}
				/>
			</SyncDataGrid>
			{
				!!viewMessageID &&
				<ViewMessagePopup
					notificationQueueID={viewMessageID}
					orderID={props.orderID}
					kindOfOrder={props.kindOfOrder}
					disableSMS={props.disableSMS}
					onHidePopup={() => {
						setViewMessageID(undefined);
					}}
					onReplyClicked={() => {
						setCreateMessagePopupVisible(true);
					}}
					onMarkAsRead={() => {
						queryClient.invalidateQueries(["messages", props.orderID, props.kindOfOrder]);
						queryClient.invalidateQueries(["unread-message-count", user?.userName], undefined, {
							refetchActive: true,
							refetchInactive: true
						} as InvalidateOptions);
					}}
				/>
			}
			{
				createMessagePopupVisible &&
				<CreateMessagePopup
					emailSubject={props.emailSubject}
					kindOfOrder={props.kindOfOrder}
					orderID={props.orderID}
					replyToMessageID={viewMessageID}
					disableSMS={props.disableSMS}
					initialMessageText={props.messageText}
					onHidePopup={() => {
						setCreateMessagePopupVisible(false);
						setViewMessageID(undefined);
					}}
					onMessageCreated={() => {
						setViewMessageID(undefined);
						queryClient.invalidateQueries(["messages", props.orderID, props.kindOfOrder]);
						props.onMessageCreated();
					}}
				/>
			}
		</>
	);
}
